import styled from 'styled-components';
import Modal from 'components/ui-components/Modal';
import Button from 'components/ui-components/Button';
import { WarningTriangle } from 'assets/icons';
import { error } from 'constants/variables';
import { messageModalTypes } from '../groups_listing/approvals_groups_reducer';

const ApprovalsGroupMessageModal = ({ options, closeModal, actionHandler }) => {
  const { showModal, type, title, description, warning, cta } = options;

  return (
    <ApprovalModal isOpen={showModal} closeModal={closeModal}>
      <div className="fl">
        {[
          messageModalTypes.DELETE_ACTIVE_GROUP,
          messageModalTypes.DELETE_ARCHIVE_GROUP,
        ].includes(type) && (
          <WarningTriangle
            fillColor={error}
            width="30"
            height="26"
            className="mr-5 approvals-modal__icon"
          />
        )}
        <h2
          className={`ff-body fw-600 fs-20 lh-1-3 tc-grey-70 mb-14 ${
            description ? '' : 'mb-35'
          }`}>
          {title}
        </h2>
      </div>
      {description && (
        <p
          className={`ff-body fs-16 lh-1-3 tc-grey-70 ${
            warning ? 'mb-28' : 'mb-35'
          }`}>
          {description}
        </p>
      )}
      {warning && (
        <p className="ff-body fs-16 lh-1-3 tc-grey-70 mb-40">{warning}</p>
      )}
      <div className="fl jc-fe">
        <Button
          className={`cef-btn cef-btn--large bg-grey-70 tc-white ${
            type !== messageModalTypes.DELETE_ARCHIVE_GROUP ? 'mr-14' : ''
          }`}
          handleClick={closeModal}>
          Cancel
        </Button>
        {type !== messageModalTypes.DELETE_ARCHIVE_GROUP && (
          <Button
            className="cef-btn cef-btn--large bg-cef-red tc-white"
            handleClick={actionHandler}>
            {cta}
          </Button>
        )}
      </div>
    </ApprovalModal>
  );
};

const ApprovalModal = styled(Modal)`
  background-color: rgba(0, 0, 0, 0.7);
  & > div {
    box-sizing: border-box;
    width: 100%;
    max-width: 475px;
    padding: 32px 24px 28px 30px;
  }
`;

export default ApprovalsGroupMessageModal;
